<div class="watch-shell">
  <header class="topbar">
    <div class="brand">
      <span class="brand-mark" aria-hidden="true"
        ><mat-icon>travel_explore</mat-icon></span
      >
      <div>
        <h1>Registrar Transparency Watch</h1>
        <p>
          Independent replay of the public event log ·
          <span class="mono">{{ apiHost }}</span>
        </p>
      </div>
    </div>

    <div class="topbar-actions">
      @if (registerCheck; as check) {
        <span
          class="sync-pill"
          [class.ok]="check.status === 'consistent'"
          [class.bad]="check.status === 'inconsistent'"
          role="status"
          [title]="
            check.status === 'unavailable'
              ? 'Register check skipped: ' + check.reason
              : 'Register compared at sequence ' +
                check.asOfSequence +
                (check.asOfSequence === throughSequence
                  ? ''
                  : ', the latest the Insights API has projected')
          "
        >
          <span class="dot" aria-hidden="true"></span>
          Log #{{ throughSequence }} ·
          {{
            check.status === "consistent"
              ? "register matches"
              : check.status === "inconsistent"
                ? "register differs"
                : "register not checked"
          }}
          @if (
            check.status !== "unavailable" &&
            check.asOfSequence !== throughSequence
          ) {
            at #{{ check.asOfSequence }}
          }
        </span>
      }
      @if (signatureCheck; as signatures) {
        <span
          class="sync-pill"
          [class.ok]="signatures.status === 'verified'"
          [class.bad]="signatures.status === 'failed'"
          role="status"
          [title]="
            signatures.status === 'unavailable'
              ? 'Signatures not checked: ' + signatures.reason
              : 'Verified against the registrar trust anchor from the discovery document'
          "
        >
          <span class="dot" aria-hidden="true"></span>
          @switch (signatures.status) {
            @case ("verified") {
              {{ signatures.checked }} signatures verified
            }
            @case ("failed") {
              {{ signatures.failed }} of {{ signatures.checked }} signatures
              failed
            }
            @case ("unavailable") {
              signatures not checked
            }
          }
        </span>
      }
      @if (treeCheck; as tree) {
        <span
          class="sync-pill"
          [class.ok]="tree.status === 'verified'"
          [class.bad]="tree.status === 'failed'"
          role="status"
          [title]="
            tree.status === 'unavailable'
              ? 'Tree head not checked: ' + tree.reason
              : 'Root hash of the tree head for ' +
                tree.treeSize +
                ' events compared with the replayed log' +
                (tree.consistency?.error
                  ? '; consistency proof not read: ' + tree.consistency.error
                  : tree.consistency
                    ? ', consistency with the tree head for ' +
                      tree.consistency.fromSize +
                      ' events checked'
                    : '')
          "
        >
          <span class="dot" aria-hidden="true"></span>
          @switch (tree.status) {
            @case ("verified") {
              tree head verified
            }
            @case ("failed") {
              tree head differs
            }
            @case ("unavailable") {
              tree head not checked
            }
          }
        </span>
      }
      <button
        type="button"
        class="toggle"
        [attr.aria-pressed]="autoRefresh"
        (click)="toggleAutoRefresh()"
        title="Refresh every minute while this tab is visible"
      >
        <mat-icon aria-hidden="true">{{
          autoRefresh ? "sync" : "sync_disabled"
        }}</mat-icon>
        Auto
      </button>
      <button
        mat-flat-button
        type="button"
        (click)="refresh()"
        [disabled]="refreshing"
      >
        <mat-icon [class.spin]="refreshing">refresh</mat-icon>
        {{ refreshing ? "Syncing" : "Sync" }}
      </button>
    </div>
  </header>

  @if (error) {
    <div class="banner bad" role="alert">
      <mat-icon aria-hidden="true">cloud_off</mat-icon>
      <span>{{ error }}</span>
      <button type="button" class="link-button" (click)="refresh()">
        Try again
      </button>
    </div>
  }

  @if (loading) {
    <section class="stat-grid" aria-hidden="true">
      @for (placeholder of [1, 2, 3, 4]; track placeholder) {
        <div class="stat panel skeleton"></div>
      }
    </section>
    <div class="loading panel" role="status">
      <mat-icon class="spin">sync</mat-icon
      ><span>Replaying the public event log…</span>
    </div>
  } @else if (context) {
    <section class="stat-grid" aria-label="Totals">
      <button type="button" class="stat panel" (click)="show('register')">
        <span>Wallet-relying parties</span><strong>{{ wrpRows.length }}</strong
        ><small>{{ validCertificates }} unrevoked certificates</small>
      </button>
      <button type="button" class="stat panel" (click)="show('activity')">
        <span>Events replayed</span><strong>{{ events.length }}</strong
        ><small
          >Through #{{ throughSequence }}
          @if (newEvents) {
            · <b>{{ newEvents }} new</b>
          }
        </small>
      </button>
      <button
        type="button"
        class="stat panel"
        [class.alert]="highCount"
        (click)="showFindings('high')"
      >
        <span>High priority</span
        ><strong class="high-text">{{ highCount }}</strong
        ><small>Requires investigation</small>
      </button>
      <button
        type="button"
        class="stat panel"
        (click)="showFindings('warning')"
      >
        <span>Warnings</span
        ><strong class="warning-text">{{ warningCount }}</strong
        ><small>Explainable anomalies</small>
      </button>
    </section>

    @if (treeCheck?.status === "failed") {
      <div class="banner bad" role="alert">
        <mat-icon aria-hidden="true">gpp_bad</mat-icon>
        <span
          >The registrar's tree head disagrees with the replayed log at sequence
          {{ throughSequence }}.</span
        >
        <button
          type="button"
          class="link-button"
          (click)="showFindings('high')"
        >
          Show R-13 findings
        </button>
      </div>
    }

    @if (registerCheck?.status === "inconsistent") {
      <div class="banner bad" role="alert">
        <mat-icon aria-hidden="true">gpp_bad</mat-icon>
        <span
          >The register API disagrees with the replayed log at sequence
          {{ context.asOfSequence }}.</span
        >
        <button
          type="button"
          class="link-button"
          (click)="showFindings('high')"
        >
          Show R-06 findings
        </button>
      </div>
    }

    <nav class="tabs" role="tablist" aria-label="Views">
      @for (item of views; track item.id) {
        <button
          type="button"
          role="tab"
          class="tab"
          [class.active]="view === item.id"
          [attr.aria-selected]="view === item.id"
          (click)="show(item.id)"
        >
          <mat-icon aria-hidden="true">{{ item.icon }}</mat-icon>
          {{ item.label }}
          <span class="tab-count">{{
            item.id === "findings"
              ? findings.length
              : item.id === "register"
                ? wrpRows.length
                : item.id === "requests"
                  ? requestedTypes
                  : events.length
          }}</span>
        </button>
      }
      @if (lastUpdated) {
        <small class="updated"
          >Synced {{ lastUpdated | date: "mediumTime" }}</small
        >
      }
    </nav>

    <div role="tabpanel">
      @switch (view) {
        @case ("findings") {
          <watch-findings-view
            [findings]="findings"
            [context]="context"
            [normalCount]="normalCount"
            [selectedId]="selectedFindingId"
            (selectedIdChange)="selectFinding($event)"
            [(severity)]="severityFilter"
            (openWrp)="openWrp($event)"
          />
        }
        @case ("register") {
          <watch-register-view
            [rows]="wrpRows"
            [findings]="findings"
            [context]="context"
            [selectedWrpId]="selectedWrpId"
            (selectedWrpIdChange)="selectWrp($event)"
            (openFinding)="openFinding($event)"
          />
        }
        @case ("requests") {
          <watch-requests-view
            [intendedUses]="intendedUses"
            [context]="context"
            [check]="intendedUseCheck"
            [selectedType]="selectedType"
            (selectedTypeChange)="selectType($event)"
          />
        }
        @case ("activity") {
          <watch-activity-view
            [events]="events"
            [context]="context"
            (openWrp)="openWrp($event)"
          />
        }
      }
    </div>
  }
</div>
